import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  transform(value: any, searchText: any = ''): any {
    try {
      searchText = searchText.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      if (!(searchText && value)) { return value; }
      const regex = new RegExp('(' + searchText + ')', 'ig');
      return value.toString().replace(regex, '<mark>$1</mark>');
    } catch (e) {
      return value;
    }
  }

}
